import React, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import axios from "axios";
import { baseURL } from "../../api";
import Chip from "@mui/material/Chip";
import { Checkbox, FormHelperText } from "@mui/material";
import CustomAlert from "../../component/AlertComponent/Alert";
import ListSubheader from "@mui/material/ListSubheader";
import { Global_Data } from "../../globalData/GlobalData";
import { vsprintf } from "sprintf-js";
import { Icon } from "../../utils/MuiIcons/Icon";
import { serverAddress } from "../../config";
import { setLocationCode } from "../../utils/store/action/varValueActions";
import { useDispatch } from "react-redux";
import ComponentLoadingBoundary from "../../component/Loading/ComponentLoadingBoundary";
import usePendingRequests from "../../component/Loading/usePendingRequests";

export default function BasicSelect({
  url,
  dataComponent,
  data,
  setdTermDays,
  summaryId,
  taxUrl,
  handleClickOpen,
  textValue,
  formIsSubmited,
  errors,
  isDisabledTable,
  setSelectAndAutocompleteSname,
  def_value,
  subTotalDef,
  onChildSelect,
  selectTax,
  handledatachange,
  taxUrlFree,
  sColumnID,
  datasend,
  selectEdit,
  datemod,
  formaction,
  isSubmited,
  isDocumentSelect,
}) {
  const [dataCollection, setDataCollection] = useState([]);
  const [taxCollection, setTaxCollection] = useState([]);
  const [taxFree, setFree] = useState([]);
  const [def_selected, setDefSelected] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [displayItems, setDisplayItems] = useState({});
  const [singleSelected, setSingleSelected] = useState({});
  const [customError, setCustomError] = useState("");
  useEffect(() => {
    if (!customError) return;
    CustomAlert("error", customError, { domain: "select", action: "load-options" });
    setCustomError("");
  }, [customError]);
  const [nativeSelected, setNativeSelected] = useState([]);
  const [defaultValueField, setDefaultValueField] = useState("");
  const [activityBTN, setActivityBTN] = useState(false);
  const [localSelectedValue, setLocalSelectedValue] = useState("");
  const { loading, trackRequest } = usePendingRequests();
  const requestSequenceRef = useRef(0);
  const currentFormValueRef = useRef("");
  const consumedDocumentSelectCycleRef = useRef(null);

  const { token, setDefaultTableSelectedLocation } = Global_Data();
  const dispatch = useDispatch();

  const valueField = data?.data?.sValueField;
  const componentName = data?.component?.sName;
  const cascadeAction = String(data?.data?.sAction || "")
    .split(":")[0]
    .trim();
  const isCascadeSet = cascadeAction === "CASCADE-SET";
  const isCascade = cascadeAction === "CASCADE";
  const documentSelectCycle =
    isDocumentSelect && typeof isDocumentSelect === "object"
      ? isDocumentSelect.cycle
      : null;
  const documentSelectMappedValue =
    documentSelectCycle !== null &&
    Object.prototype.hasOwnProperty.call(
      isDocumentSelect?.values || {},
      componentName
    )
      ? normalizeReportTemplateValue(
          componentName,
          isDocumentSelect.values[componentName]
        )
      : "";
  const hasError = Boolean(errors);
  const helperMessage = errors || data?.component?.sHelper || "";
  const selectLabelId = `${componentName}-label`;
  const helperTextId = `${componentName}-helper-text`;

  currentFormValueRef.current = normalizeReportTemplateValue(
    componentName,
    textValue?.[componentName]
  );

  const selectedValue =
    summaryId === "summ_tax"
      ? def_selected || ""
      : localSelectedValue || "";

  function normalizeReportTemplateValue(
      componentName,
      value
    ) {
      if (
        value === undefined ||
        value === null ||
        value === ""
      ) {
        return "";
      }

      const stringValue =
        String(value).trim();

      const isReportTemplateField =
        componentName ===
          "sDefaultForm" ||
        componentName ===
          "sFormTemplate";

      if (
        isReportTemplateField &&
        /^\d+$/.test(stringValue)
      ) {
        return String(
          Number(stringValue)
        );
      }

      return stringValue;
    }
  function extractDisplayValues(inputString = "") {
    const regex = /\{([^}]+)\}/g;
    const matches = [];
    let match;

    while ((match = regex.exec(inputString)) !== null) {
      matches.push(match[1]);
    }

    return matches.reduce((acc, item, index) => {
      acc[`display${index + 1}`] = item;
      return acc;
    }, {});
  }

  function replaceUriParams(values = {}, uri = "") {
    let nextUri = uri;

    Object.keys(values || {}).forEach(key => {
      const value = values[key];

      if (value !== undefined && value !== null && String(value).trim() !== "") {
        nextUri = nextUri.replace(new RegExp(`{${key}}`, "g"), value);
      }
    });

    return nextUri;
  }

  function replaceTextValues(displayFormat = "", values = {}) {
    return displayFormat.replace(/\{([^}]+)\}/g, (match, key) => {
      const value = values?.[key];

      return value !== undefined && value !== null && String(value).trim() !== ""
        ? value
        : match;
    });
  }

  function replacePlaceholders(uri = "", values = {}) {
    return uri.replace(/\{([^}]+)\}/g, (match, placeholder) => {
      return Object.prototype.hasOwnProperty.call(values, placeholder)
        ? values[placeholder]
        : match;
    });
  }

  function hasUnresolvedPlaceholders(value = "") {
    return /\{[^}]+\}/.test(String(value));
  }

  function renderDisplay(item) {
    if (!item || item === "" || Object.keys(item || {}).length === 0) return "";

    try {
      return vsprintf(
        data?.data?.sDisplayFormat || "%s",
        replacePlaceholders(data?.data?.sDisplayField || "", item)
          ?.replace(/[{}]/g, "")
          ?.split(",")
      );
    } catch {
      return item?.[valueField] || "";
    }
  }

  function renderDisplayHtml(item) {
    return (
      <div
        component="span"
        style={{ width: "100%" }}
        dangerouslySetInnerHTML={{ __html: renderDisplay(item) }}
      />
    );
  }

  function getLabel() {
    return formaction === "EDIT"
      ? datemod === "FREEFORM"
        ? selectedOption
        : dataComponent?.sLabel
      : dataComponent?.sLabel;
  }

  function getCurrentSelectedObject() {
    const normalizedSelectedValue =
      normalizeReportTemplateValue(
        componentName,
        selectedValue
      );

    return (
      dataCollection?.find(item => {
        const optionValue =
          normalizeReportTemplateValue(
            componentName,
            item?.[valueField]
          );

        return (
          optionValue ===
          normalizedSelectedValue
        );
      }) ||
      singleSelected ||
      {}
    );
  }

  function renderHelperText() {
    return (
      <FormHelperText error={hasError} id={helperTextId}>
        {helperMessage}
      </FormHelperText>
    );
  }

  const uniqueClasses = Array.from(
    new Set(dataCollection.map(item => item?.[data?.data?.sGroupField]))
  );

  function renderMenuItems({ includeAddNew = false } = {}) {
  const hasGroupField = Boolean(data?.data?.sGroupField);
  const items = [];

  const getOptionValue = item => {
      return normalizeReportTemplateValue(
        componentName,
        item?.[valueField]
      );
    };

  if (includeAddNew) {
    items.push(
      <MenuItem
        key="addnew"
        value="addnew"
        disabled={activityBTN}
        {...data?.data?.sAdd?.sMessageProps}
      >
        <Icon
          iconName={data?.data?.sAdd?.sAddIcon}
          sProps={data?.data?.sAdd?.sIconProps}
        />
        {data?.data?.sAdd?.sAddMessage}
      </MenuItem>
    );
  }

    items.push(
    <MenuItem key="none" value="">
      <Box
        sx={{
          color: "text.secondary",
          fontStyle: "italic"
        }}
      >
        None
      </Box>
    </MenuItem>
  );

  if (hasGroupField) {
      uniqueClasses.forEach(className => {
        items.push(
          <ListSubheader
            key={`header-${className}`}
          >
            {className?.toUpperCase?.() || ""}
          </ListSubheader>
        );

        dataCollection
          .filter(
            item =>
              item?.[
                data?.data?.sGroupField
              ] === className
          )
          .forEach(item => {
            const optionValue =
              getOptionValue(item);

            items.push(
              <MenuItem
                key={optionValue}
                value={optionValue}
                style={{
                  whiteSpace: "pre-line"
                }}
              >
                <Box sx={{ marginLeft: 2 }}>
                  {renderDisplayHtml(item)}
                </Box>
              </MenuItem>
            );
          });
      });
    } else {
      dataCollection.forEach(item => {
        const optionValue =
          getOptionValue(item);

        items.push(
          <MenuItem
            key={optionValue}
            value={optionValue}
            style={{
              whiteSpace: "pre-line"
            }}
          >
            <Box sx={{ marginLeft: 2 }}>
              {renderDisplayHtml(item)}
            </Box>
          </MenuItem>
        );
      });
    }

    return items;
  }

  useEffect(() => {
    if (isSubmited) {
      setTaxCollection([]);
      setDataCollection([]);
      setFree([]);
      setSelectedOption("");
      setSelectedOptions([]);
      setCustomError("");
      setLocalSelectedValue("");
      setSingleSelected({});
    }
  }, [isSubmited]);

  useEffect(() => {
    if (dataCollection.length > 0) {
      setDisplayItems(extractDisplayValues(data?.data?.sDisplayFormat));
    }
  }, [dataCollection, data]);

  useEffect(() => {
    const formValue =
      textValue?.[componentName];

    if (
      formValue === undefined ||
      formValue === null
    ) {
      return;
    }

    setLocalSelectedValue(
      normalizeReportTemplateValue(
        componentName,
        formValue
      )
    );
  }, [
    textValue?.[componentName],
    componentName
  ]);

  useEffect(() => {
    if (
      !localSelectedValue ||
      dataCollection.length === 0
    ) {
      return;
    }

    const selected =
      dataCollection.find(item => {
        const optionValue =
          normalizeReportTemplateValue(
            componentName,
            item?.[valueField]
          );

        return (
          optionValue ===
          normalizeReportTemplateValue(
            componentName,
            localSelectedValue
          )
        );
      });

    if (selected) {
      setSingleSelected(selected);
    }
  }, [
    localSelectedValue,
    dataCollection,
    valueField,
    componentName
  ]);

  useEffect(() => {
    if (summaryId === "summ_tax") {
      trackRequest(() =>
        axios.get(`${baseURL}${taxUrl}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
      )
        .then(result => {
          setTaxCollection(result?.data?.data || []);
        })
        .catch(() => {
          setCustomError("Something went Wrong");
        });

      return;
    }

    if (sColumnID === "col_taxdescription") {
      trackRequest(() =>
        axios.get(`${baseURL}${taxUrlFree}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
      )
        .then(result => {
          const records = result?.data?.data?.records || result?.data?.data || [];
          setFree(result?.data?.data?.records || []);
          setDataCollection(records);
        })
        .catch(() => {
          setCustomError("Something went Wrong");
        });

      return;
    }

    if (!url) return;

    const requestId = ++requestSequenceRef.current;
    const valueAtRequestStart = currentFormValueRef.current;
    const documentSelectCycleAtRequestStart = documentSelectCycle;
    const documentSelectValueAtRequestStart = documentSelectMappedValue;
    const preserveDocumentSelectValue =
      documentSelectCycleAtRequestStart !== null &&
      consumedDocumentSelectCycleRef.current !==
        documentSelectCycleAtRequestStart &&
      documentSelectValueAtRequestStart !== "" &&
      valueAtRequestStart === documentSelectValueAtRequestStart;

    const uri = replaceUriParams(
      textValue,
      url?.startsWith("/") ? `${baseURL}${url}` : `${baseURL}/${url}`
    );

    const newUrl = replaceTextValues(uri, textValue);

    // A dependent SELECT must not call the API until every dependency exists.
    if (hasUnresolvedPlaceholders(newUrl)) {
      setDataCollection([]);
      return;
    }

    trackRequest(() =>
      axios.get(newUrl, {
        headers: { Authorization: `Bearer ${token}` },
      })
    )
      .then(result => {
        if (requestId !== requestSequenceRef.current) return;

        const records = result?.data?.data?.records || result?.data?.data || [];
        setDataCollection(records);

        if (preserveDocumentSelectValue) {
          consumedDocumentSelectCycleRef.current =
            documentSelectCycleAtRequestStart;

          // Do not undo a newer manual selection made while this request ran.
          if (
            currentFormValueRef.current ===
            documentSelectValueAtRequestStart
          ) {
            const documentSelectedRecord = records.find(record =>
              normalizeReportTemplateValue(
                componentName,
                record?.[valueField]
              ) === documentSelectValueAtRequestStart
            );

            if (documentSelectedRecord) {
              setSingleSelected(documentSelectedRecord);
              datasend(
                documentSelectValueAtRequestStart,
                documentSelectedRecord,
                componentName
              );
            }

            setLocalSelectedValue(documentSelectValueAtRequestStart);
            return;
          }
        }

        let cascadeValue = {};

        if (isCascadeSet) {
          cascadeValue = records.find(record =>
            defaultValueField &&
            Object.prototype.hasOwnProperty.call(record, defaultValueField) &&
            record[defaultValueField] !== "" &&
            record[defaultValueField] === "Yes"
          ) || {};
        } else if (isCascade) {
          // Preserve the established CASCADE behavior of using the last record.
          cascadeValue = records[records.length - 1] || {};
        }

        if (
          Object.values(cascadeValue || {}).length > 0 &&
          formaction !== "EDIT" &&
          currentFormValueRef.current === valueAtRequestStart
        ) {
          const cascadeSelectedValue = String(cascadeValue?.[valueField] ?? "");

          setSingleSelected(cascadeValue);
          setLocalSelectedValue(cascadeSelectedValue);

          datasend(
            cascadeSelectedValue,
            cascadeValue,
            componentName
          );
        }
      })
      .catch(err => {
        if (requestId !== requestSequenceRef.current) return;
        setCustomError(err?.response?.data?.metadata?.msg || "Something went Wrong");
      });

    return () => {
      if (requestId === requestSequenceRef.current) {
        requestSequenceRef.current += 1;
      }
    };
  }, [
    formIsSubmited,
    isSubmited,
    textValue?.[
      data?.data?.sDataAware && data?.data?.sDataAware?.replace(/[{}]/g, "")
    ],
    url,
    token,
    valueField,
    defaultValueField,
    isCascadeSet,
    isCascade,
    documentSelectCycle,
    documentSelectMappedValue,
    componentName,
  ]);

  useEffect(() => {
    if (!textValue?.[componentName] || !isDocumentSelect) {
      return;
    }

    const currentValue =
      normalizeReportTemplateValue(
        componentName,
        textValue?.[componentName]
      );

    const selected =
      dataCollection.find(item => {
        const optionValue =
          normalizeReportTemplateValue(
            componentName,
            item?.[valueField]
          );

        return optionValue === currentValue;
      });

    if (selected) {
      setSingleSelected(selected);

      setLocalSelectedValue(
        normalizeReportTemplateValue(
          componentName,
          selected?.[valueField]
        )
      );
    }

    if (
      documentSelectCycle !== null &&
      consumedDocumentSelectCycleRef.current !== documentSelectCycle &&
      documentSelectMappedValue !== "" &&
      currentValue === documentSelectMappedValue &&
      dataCollection.length > 0
    ) {
      if (selected) {
        datasend(
          documentSelectMappedValue,
          selected,
          componentName
        );
      }

      consumedDocumentSelectCycleRef.current = documentSelectCycle;
    }
  }, [
    textValue?.[componentName],
    dataCollection,
    isDocumentSelect,
    valueField,
    componentName,
    documentSelectCycle,
    documentSelectMappedValue,
    datasend
  ]);

  useEffect(() => {
    if (singleSelected?.sLocationCode) {
      setDefaultTableSelectedLocation(singleSelected.sLocationCode);
      dispatch(setLocationCode(singleSelected.sLocationCode));
    }
  }, [singleSelected?.sLocationCode]);

  function openModalforGroupAdd(data) {
    const mode = {
      options: {
        mode: "DEFAULT",
        handler: "handleDialog",
        dialog: data?.data?.sAdd?.sAddForm,
        sDataSource: data?.data?.sDataSource,
      },
    };

    handleClickOpen("s", mode);
  }

  const handleChange = event => {
  const nextSelectedValue = String(
    event?.target?.value ?? ""
  );

  if (
    nextSelectedValue === "addnew" &&
    dataComponent?.options?.mode === "ADD"
  ) {
    openModalforGroupAdd(data);

    setSelectAndAutocompleteSname({
      name: componentName,
      value: valueField
    });

    return;
  }

  setLocalSelectedValue(
    nextSelectedValue
  );

  if (nextSelectedValue === "") {
    setSingleSelected({});
    handledatachange("");

    datasend(
      "",
      {},
      componentName
    );

    return;
  }

  const selected =
  dataCollection?.find(option => {
    const optionValue =
      normalizeReportTemplateValue(
        componentName,
        option?.[valueField]
      );

    return (
      optionValue ===
      normalizeReportTemplateValue(
        componentName,
        nextSelectedValue
      )
    );
  });

  setSingleSelected(selected || {});
  handledatachange(selected || {});

  /*
   * Third parameter must identify the form component,
   * not the source option field.
   *
   * sDefaultForm, not sReportID.
   */
  datasend(
    nextSelectedValue,
    selected || {},
    componentName
  );
};

  const handleNativeChange = event => {
    const nextSelectedValue = event?.target?.value;

    if (nextSelectedValue === "") {
      setNativeSelected([]);
      return;
    }

    setNativeSelected(prevState => {
      const exists = prevState.some(option => option === nextSelectedValue);
      return exists
        ? prevState.filter(option => option !== nextSelectedValue)
        : [...prevState, nextSelectedValue];
    });
  };

  const handleOptionSelect = event => {
    const selectedValues = event.target.value;
    const lastSelectedValue = selectedValues[selectedValues.length - 1];

    setSelectedOptions(prevState => {
      const exists = prevState.some(
        option => option?.[valueField] === lastSelectedValue
      );

      if (exists) {
        return prevState.filter(option => option?.[valueField] !== lastSelectedValue);
      }

      const newSelectedOption = dataCollection?.find(
        option => option?.[valueField] === lastSelectedValue
      );

      return [...prevState, newSelectedOption];
    });
  };

  const handleChangeTax = event => {
    const nextValue = event.target.value;
    setSelectedOption(nextValue);
    handledatachange(nextValue);
  };

  function getVATPercentage(vatString) {
    const matches = vatString && vatString?.match(/\((\d+(\.\d+)?)%\)/);
    return matches?.[1] ? parseFloat(matches[1]) : null;
  }

  const vald = subTotalDef ? getVATPercentage(subTotalDef?.summ_tax) : null;

  useEffect(() => {
    setDefSelected(selectedOption === "" ? +vald : selectedOption);
  }, [selectedOption, vald]);

  useEffect(() => {
    setNativeSelected([textValue?.[sColumnID]]);
  }, [textValue?.[sColumnID]]);

  useEffect(() => {
    if (isCascadeSet) {
      setDefaultValueField(data?.data?.sAction?.split(":")?.[1]);
    } else {
      setDefaultValueField("");
    }
  }, [data, isCascadeSet]);

  useEffect(() => {
    if (data?.data?.sAdd?.sFormName && data?.data?.sAdd?.sAction) {
      const urlCapture =
        serverAddress +
        `/form/isallowed/transaction?module=${data?.data?.sAdd?.sFormName}&activity=${data?.data?.sAdd?.sAction}`;

      trackRequest(() =>
        axios.get(urlCapture, {
          headers: { Authorization: `Bearer ${token}` },
        })
      )
        .then(result => {
          if (result.data.data.Access === "No") {
            setActivityBTN(true);
          }
        })
        .catch(error => {
          console.error(error, "error456");
        });
    }
  }, [data, token]);

  useEffect(() => {
    const isReportTemplateField =
      componentName === "sDefaultForm" ||
      componentName === "sFormTemplate";

    if (
      !isReportTemplateField ||
      dataCollection.length === 0
    ) {
      return;
    }

    const originalValue =
      textValue?.[componentName];

    const normalizedValue =
      normalizeReportTemplateValue(
        componentName,
        originalValue
      );

    if (
      !normalizedValue ||
      String(originalValue) ===
        normalizedValue
    ) {
      return;
    }

    const matchingOption =
      dataCollection.find(item => {
        return (
          normalizeReportTemplateValue(
            componentName,
            item?.[valueField]
          ) === normalizedValue
        );
      });

    if (!matchingOption) {
      return;
    }

    setLocalSelectedValue(
      normalizedValue
    );

    setSingleSelected(
      matchingOption
    );

    /*
    * Update the global form state:
    * "00003" becomes "3".
    */
    datasend(
      normalizedValue,
      matchingOption,
      componentName
    );
  }, [
    dataCollection,
    componentName,
    valueField,
    textValue?.[componentName]
  ]);
  return (
    <ComponentLoadingBoundary
      loading={loading}
      label={`Loading ${dataComponent?.sLabel || componentName}`}
      minHeight={40}
      size={20}
    >

      <Box>
        {dataComponent?.options?.mode === "DEFAULT" && (
          <FormControl
            {...data?.component?.options?.textFieldProps}
            fullWidth
            error={hasError}
          >
            <InputLabel id={selectLabelId}>{getLabel()}</InputLabel>

            <Select
              {...data?.component?.sProps}
              {...data?.component?.sProps?.InputProps}
              {...data?.component?.options?.textFieldProps}
              labelId={selectLabelId}
              id={textValue?.id ? `${componentName}-${textValue.id}` : componentName}
              fullWidth
              name={componentName}
              label={dataComponent?.sLabel}
              disabled={isDisabledTable}
              error={hasError}
              value={selectedValue}
              onChange={handleChange}
              renderValue={() => {
                if (!selectedValue) {
                  return (
                    <Box
                      sx={{
                        color: "text.secondary",
                        fontStyle: "italic"
                      }}
                    >
                      None
                    </Box>
                  );
                }

                const selected = getCurrentSelectedObject();

                return (
                  <span style={{ whiteSpace: "pre-line" }}>
                    {renderDisplayHtml(selected)}
                  </span>
                );
              }}
            >
              {renderMenuItems()}
            </Select>

            {renderHelperText()}
          </FormControl>
        )}

        {dataComponent?.options?.mode === "ADD" && (
          <FormControl
            {...data?.component?.options?.textFieldProps}
            error={hasError}
          >
            <InputLabel id={selectLabelId}>{getLabel()}</InputLabel>

            <Select
              {...data?.component?.sProps}
              {...data?.component?.options?.textFieldProps}
              labelId={selectLabelId}
              id={componentName}
              name={componentName}
              label={dataComponent?.sLabel}
              disabled={isDisabledTable}
              error={hasError}
              value={selectedValue}
              onChange={handleChange}
              renderValue={() => {
                if (!selectedValue) return "";
                return renderDisplayHtml(getCurrentSelectedObject());
              }}
            >
              {renderMenuItems({ includeAddNew: true })}
            </Select>

            {renderHelperText()}
          </FormControl>
        )}

        {dataComponent?.options?.mode === "MULTISELECT" &&
          dataComponent?.options?.submode === "DEFAULT" && (
            <FormControl
              {...dataComponent?.options?.textFieldProps}
              error={hasError}
            >
              <InputLabel id={selectLabelId}>{getLabel()}</InputLabel>

              <Select
                {...data?.component?.sProps}
                {...data?.component?.options?.textFieldProps}
                multiple
                value={selectedOptions}
                onChange={handleOptionSelect}
                label={dataComponent?.sLabel}
                size="small"
                error={hasError}
                renderValue={() => (
                  <div>
                    {selectedOptions?.map(item => renderDisplayHtml(item))}
                  </div>
                )}
              >
                <MenuItem value=""> </MenuItem>
                {renderMenuItems()}
                {taxCollection?.map(option => (
                  <MenuItem key={option?.[valueField]} value={option?.[valueField]}>
                    {option[displayItems.display1]} {option[displayItems.display2]}
                  </MenuItem>
                ))}
                {taxFree?.map(option => (
                  <MenuItem key={option?.[valueField]} value={option?.[valueField]}>
                    {option[displayItems.display1]} {option[displayItems.display2]}
                  </MenuItem>
                ))}
              </Select>

              {renderHelperText()}
            </FormControl>
          )}

        {dataComponent?.options?.mode === "MULTISELECT" &&
          dataComponent?.options?.submode === "CHECKBOXES" && (
            <FormControl
              {...dataComponent?.options?.textFieldProps}
              error={hasError}
            >
              <InputLabel id={selectLabelId}>{getLabel()}</InputLabel>

              <Select
                {...data?.component?.sProps}
                {...data?.component?.options?.textFieldProps}
                multiple
                value={selectedOptions}
                onChange={handleOptionSelect}
                error={hasError}
                renderValue={items => (
                  <>
                    {items?.map(item => renderDisplayHtml(item))}
                  </>
                )}
              >
                {dataCollection.map(item => (
                  <MenuItem
                    key={item?.[valueField]}
                    value={item?.[valueField]}
                    style={{ whiteSpace: "pre-line" }}
                  >
                    <Box
                      sx={{
                        marginLeft: 2,
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <Checkbox
                        checked={
                          selectedOptions?.find(
                            option => option?.[valueField] === item?.[valueField]
                          ) !== undefined
                        }
                      />
                      {renderDisplayHtml(item)}
                    </Box>
                  </MenuItem>
                ))}
              </Select>

              {renderHelperText()}
            </FormControl>
          )}

        {dataComponent?.options?.mode === "MULTISELECT" &&
          dataComponent?.options?.submode === "CHIP" && (
            <FormControl
              {...dataComponent?.options?.textFieldProps}
              error={hasError}
            >
              <InputLabel id={selectLabelId}>{getLabel()}</InputLabel>

              <Select
                {...data?.component?.sProps}
                {...data?.component?.options?.textFieldProps}
                multiple
                value={selectedOptions}
                onChange={handleOptionSelect}
                label={dataComponent?.sLabel}
                error={hasError}
                renderValue={() => (
                  <Box>
                    {selectedOptions?.map(option => (
                      <Chip
                        key={option?.[valueField]}
                        label={renderDisplay(option)}
                      />
                    ))}
                  </Box>
                )}
              >
                <MenuItem value=""> </MenuItem>
                {renderMenuItems()}
                {taxCollection?.map(option => (
                  <MenuItem key={option?.[valueField]} value={option?.[valueField]}>
                    {option[displayItems.display1]}{" "}
                    {option[displayItems.display2] &&
                      ` (${option[displayItems.display2]})`}
                  </MenuItem>
                ))}
                {taxFree?.map(option => (
                  <MenuItem key={option?.[valueField]} value={option?.[valueField]}>
                    {option[displayItems.display1]}{" "}
                    {option[displayItems.display2] &&
                      ` (${option[displayItems.display2]})`}
                  </MenuItem>
                ))}
              </Select>

              {renderHelperText()}
            </FormControl>
          )}

        {dataComponent?.options?.mode === "MULTISELECT" &&
          dataComponent?.options?.submode === "NATIVE" && (
            <FormControl
              {...dataComponent?.options?.textFieldProps}
              error={hasError}
            >
              <InputLabel id={selectLabelId} shrink>
                {getLabel()}
              </InputLabel>

              <Select
                {...data?.component?.sProps}
                {...data?.component?.options?.textFieldProps}
                multiple
                native
                value={nativeSelected}
                onChange={handleNativeChange}
                label={dataComponent?.sLabel}
                error={hasError}
                inputProps={{ id: "select-multiple-native" }}
              >
                <option value=""> </option>
                {dataCollection?.map(item => (
                  <option key={item?.[valueField]} value={item?.[valueField]}>
                    {renderDisplay(item)}
                  </option>
                ))}
                {taxCollection?.map(item => (
                  <option key={item?.display} value={item?.display}>
                    {item[displayItems.display1]}{" "}
                    {item[displayItems.display2] &&
                      ` (${item[displayItems.display2]})`}
                  </option>
                ))}
                {taxFree?.map(item => (
                  <option key={item?.display} value={item?.display}>
                    {item[displayItems.display1]}{" "}
                    {item[displayItems.display2] &&
                      ` (${item[displayItems.display2]})`}
                  </option>
                ))}
              </Select>

              {renderHelperText()}
            </FormControl>
          )}

        {sColumnID === "col_taxdescription" && (
          <FormControl
            {...dataComponent?.options?.textFieldProps}
            error={hasError}
          >
            <InputLabel id={selectLabelId}>{getLabel()}</InputLabel>

            <Select
              {...data?.component?.sProps}
              {...data?.component?.options?.textFieldProps}
              labelId={selectLabelId}
              id="demo-simple-select"
              label={dataComponent?.sLabel}
              value={selectedOption || ""}
              onChange={handleChangeTax}
              error={hasError}
            >
              <MenuItem value=""> </MenuItem>

              {dataCollection?.map(option => (
                <MenuItem key={option?.[valueField]} value={option?.[valueField]}>
                  {renderDisplayHtml(option)}
                </MenuItem>
              ))}

              {taxCollection?.map(option => (
                <MenuItem key={option?.[valueField]} value={option?.[valueField]}>
                  {option.display}
                </MenuItem>
              ))}

              {taxFree?.map(option => (
                <MenuItem key={option?.[valueField]} value={option?.[valueField]}>
                  {option[displayItems.display1]} {option[displayItems.display2]}
                </MenuItem>
              ))}
            </Select>

            {renderHelperText()}
          </FormControl>
        )}
      </Box>
    </ComponentLoadingBoundary>
  );
}
